import React from 'react'
import { Box, Card, CardMedia, Grid, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

interface StaticCategoryCardProps {
  onClick: () => void
  title: string
  image?: string
}

const useStyles = makeStyles()(theme => ({
  cardContainer: {
    width: '100%',
    [theme.breakpoints.only('sm')]: {
      '&:nth-child(odd)': {
        paddingRight: theme.spacing(1),
      },
      '&:nth-child(even)': {
        paddingLeft: theme.spacing(1),
      },
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  cardTitle: {
    position: 'relative',
    fontSize: '24px',
    fontWeight: 400,
    lineHeight: '32px',
    color: theme.palette.common.white,
    zIndex: 1,
  },
  staticCard: {
    position: 'relative',
    width: '100%',
    height: '15vw',

    padding: 0,
    display: 'block',
    [theme.breakpoints.down('md')]: {
      height: '30vw',
      width: '100%',
    },
    [theme.breakpoints.down('sm')]: {
      height: '40vw',
    },
  },
  cardBackground: {
    width: '100%',
    height: '100%',
    transition: 'all 0.5s ease-in-out',
    '&:hover': {
      transform: 'scale(1.03)',
    },
  },
  textWrapper: {
    position: 'absolute',
    bottom: theme.spacing(4),
    marginLeft: theme.spacing(2),
  },
}))

/*
 * This component renders a black card with a title on shop homepage
 */
const StaticCategoryCard: React.FC<StaticCategoryCardProps> = ({ onClick, title, image }) => {
  const { classes } = useStyles()
  return (
    <Grid className={classes.cardContainer} item xs={12} sm={6}>
      <Card className={classes.staticCard} onClick={onClick}>
        {image && <CardMedia className={classes.cardBackground} component="img" image={image} alt={title} />}
        <Box className={classes.textWrapper}>
          <Typography className={classes.cardTitle}>{title}</Typography>
        </Box>
      </Card>
    </Grid>
  )
}

export default StaticCategoryCard
